<template>
  <div>
    <list-vue
      v-bind:busqueda="busqueda"
      v-bind:busquedaTraduccion="busquedaTraduccion"
      v-bind:busquedaMedidas="busquedaMedidas"
      v-bind:opciones="opciones"
      v-bind:moduloTitulo="moduloTitulo"
      v-bind:pantallaTitulo="pantallaTitulo"
      v-bind:rutaConsulta="rutaConsulta"
      v-bind:buttonsPage="buttonsPage"
      v-bind:busquedaCampos="busquedaCampos"
      v-bind:permisos="permisos"
    ></list-vue>
  </div>
</template>
    <script type="text/javascript">
import { mapState } from "vuex";
import { mapMutations } from "vuex";
export default {
  data() {
    return {
      permisos: {},
      //Definimos los nombres generales
      moduloTitulo: this.$root.trans("Informacion Documentada - Pendientes"),
      reporte: false,
      pantallaTitulo: this.$root.trans("Resultado"),
      rutaConsulta: this.$route.fullPath,
      buttonsPage: [
        {
          type: "button",
          externalCheck: true,
          submitCheckbox: true,
          singleCheckbox: true,
          class: "btn btn-xs btn-warning pull-right",
          route: this.$root.UrlBase("informacion-documentada/acciones/regresar-etapa"),
          text: "Regresar",
          name: "sel",
          description: '<i class="fa fa-plus">',
          permisos: {
            opcion: "RPD",
            tarea: "RE",
          },
        },
        {
          type: "button",
          submitCheckbox: true,
          class: "btn btn-xs btn-info pull-right",
          route: this.$root.UrlBase(
            "informacion-documentada/acciones/derivar-fichas/derivacion"
          ),
          text: "Derivar",
          name: "sel",
          description: '<i class="fa fa-plus">',
          permisos: {
            opcion: "RPD",
            tarea: "DE",
          },
        },
        {
          type: "button",
          externalCheck: true,
          submitCheckbox: true,
          singleCheckbox: true,
          class: "btn btn-xs btn-success pull-right",
          route: this.$root.UrlBase("informacion-documentada/acciones/adjuntar-archivo"),
          text: "Adjuntar",
          name: "sel",
          description: '<i class="fa fa-plus">',
        },
      ],
      //Definimos los campos de busqueda, sus nombres e incluso tamaño
      busqueda: {
        sel: "",
        f___codigo_ficha: "",
        f___descripcion: "",
        f___etapa_actual_id: "",
        f___responsable_actual_id: "",
        f___cali_tipos_nc_id: "",
      },
      busquedaTraduccion: {
        sel: this.$root.trans("Sel."),
        f___codigo_ficha: this.$root.trans("Codigo"),
        f___descripcion: this.$root.trans("Descripción"),
        f___etapa_actual_id: this.$root.trans("Etapa Actual"),
        f___responsable_actual_id: this.$root.trans("Responsable Actual"),
        f___cali_tipos_nc_id: this.$root.trans("Tipo Ficha"),
      },
      busquedaCampos: {
        f___responsable_actual_id: {
          type: "select",
          options: [],
        },
        f___etapa_actual_id: {
          type: "select",
          options: [],
        },
        f___cali_tipos_nc_id: {
          type: "select",
          options: [],
        },
        // vencimiento: {
        //   type: "date",
        // },
        // creacion: {
        //   type: "date",
        // },
        // fecha_derivado: {
        //   type: "date",
        // },
        sel: {
          type: "checkbox",
        },
      },
      busquedaMedidas: {
        sel: "50px",
        f___codigo_ficha: "93px",
        f___descripcion: "250px",
        f___etapa_actual_id: "100px",
        f___responsable_actual_id: "70px",
        f___cali_tipos_nc_id: "100px",
      },
      //definimos las opciones con enlace simple para ello usamos el nombre de la ruta y en caso de eliminar usamos la ruta
      opciones: [
        // {
        //   class: "btn btn-sm btn-warning",
        //   icon: "fas fa-edit",
        //   routerName: "TiposRegistroEdit",
        //   param: "codigo",
        //   eliminar: false,
        //   nombre: "Editar",
        // },
        // {
        //     class:'btn btn-sm btn-danger',
        //     icon:'fa fa-trash-alt',
        //     routerName:'/backend/authors/delete/',
        //     param:'id',
        //     eliminar:true,
        //     nombre:'Eliminar'
        // }
      ],
    };
  },
  computed: {
    ...mapState(["request"]),
  },
  methods: {
    ...mapMutations({ requestSet: "request" }),
  },
  mounted() {
    this.requestSet(this.$route.query);
  },
  created() {
    this.requestSet(this.$route.query);

    const data = {
      selects: {
        User2: {},
        generic: {
          code: "id",
          label: "descripcion",
          model: "FichasEtapaNC",
          order: "descripcion",
          nc: "NO",
          concatena_descripcion: ["nodo_numer", "descrip_clasifica"],
          where: {
            "cali_etapas_tipo_nc.estado": "A",
          },
        },
        generic2: {
          code: "id",
          label: "descripcion",
          model: "TipoNC",
          order: "descripcion",
          nc: "NO",
        },
      },
    };
    this.$root
      .Consulta(
        this.$root.UrlBase("selects/init-new"),
        data,
        "post",
        false,
        false,
        false,
        "",
        false
      )
      .then((response) => {
        this.busquedaCampos.f___responsable_actual_id.options = response.User2;
        this.busquedaCampos.f___etapa_actual_id.options = response.generic;
        this.busquedaCampos.f___cali_tipos_nc_id.options = response.generic2;
      });
    this.$root
      .Consulta(
        this.$root.UrlBase("permisos"),
        data,
        "post",
        false,
        false,
        false,
        "",
        false
      )
      .then((response) => {
        this.permisos = response;
      });
  },
};
</script>
